package com.tregz.design.window

import androidx.compose.foundation.layout.BoxWithConstraints
import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.compose.runtime.compositionLocalOf
import androidx.compose.ui.Modifier

/** The [WindowClass] of the enclosing [WindowProvider]; phone portrait outside of one. */
val LocalWindowClass = compositionLocalOf {
    WindowClass(WindowWidth.Compact, WindowHeight.Expanded)
}

/**
 * Measures the space it is given and exposes it as a [WindowClass], both to [content] and to
 * everything below through [LocalWindowClass]. Works the same on every target, so layouts do not
 * depend on a platform window API.
 */
@Composable
fun WindowProvider(
    modifier: Modifier = Modifier.fillMaxSize(),
    content: @Composable (WindowClass) -> Unit
) {
    BoxWithConstraints(modifier) {
        val windowClass = windowClassOf(maxWidth, maxHeight)
        CompositionLocalProvider(LocalWindowClass provides windowClass) {
            content(windowClass)
        }
    }
}
